import React, { useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import Button from "../ui/Button";
import Container from "../layout/Container";
import { Cal, Pip } from "../characters/Character";
import { Cloud, CloudSoft } from "../characters/Clouds";
import { useI18n } from "../../i18n/I18nProvider";

const Cta = () => {
  const { t } = useI18n();
  const reduced = useReducedMotion();
  const magnet = useRef(null);

  const onMove = (event) => {
    const node = magnet.current;
    if (!node || reduced) return;
    const rect = node.getBoundingClientRect();
    const dx = Math.max(-8, Math.min(8, (event.clientX - (rect.left + rect.width / 2)) / 8));
    const dy = Math.max(-8, Math.min(8, (event.clientY - (rect.top + rect.height / 2)) / 8));
    node.style.transform = `translate(${dx}px, ${dy}px)`;
  };

  const onLeave = () => {
    if (magnet.current) magnet.current.style.transform = "translate(0, 0)";
  };

  return (
    <section className="relative overflow-hidden bg-lilac py-20 text-[#241c3e] md:py-28">
      <motion.div
        className="absolute left-6 top-24 z-20 hidden md:block"
        initial={reduced ? false : { y: 36, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <Cal size={96} />
      </motion.div>
      <motion.div
        className="absolute bottom-8 right-8 z-20 hidden md:block"
        initial={reduced ? false : { y: 48, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
      >
        <Pip size={84} />
      </motion.div>
      <Container className="relative z-10">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-body font-medium text-accent">{t("cta.kicker")}</p>
          <h2 className="mt-4 text-heading font-bold tracking-heading text-[#241c3e] md:text-heading-lg">
            {t("cta.title")}
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-body text-[#3c3654]">{t("cta.body")}</p>
          <div
            className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center"
            onMouseMove={onMove}
            onMouseLeave={onLeave}
          >
            <span ref={magnet} className="inline-flex w-full transition-transform sm:w-auto">
              <Button href="https://me.influ8.app" arrow className="h-12 w-full !bg-[#0b0b0f] px-6 !text-white hover:!bg-[#1c1830] sm:w-auto">
                {t("hero.app")}
              </Button>
            </span>
            <Button
              href="https://dashboard.influ8.app"
              variant="outline"
              className="h-12 !bg-white px-6 !text-[#241c3e]"
            >
              {t("cta.advertiser")}
            </Button>
          </div>
        </div>
      </Container>
      <Cloud className="pointer-events-none absolute -left-8 bottom-0 w-64 text-white/80" />
      <CloudSoft className="pointer-events-none absolute -right-6 top-4 w-52 text-white/70" />
    </section>
  );
};

export default Cta;
